import {
  Action,
  ActionType,
  UpdateQuestionnairesResponse,
} from "models/questionnaires/updateQuestionnaires";
import createReducer from "../../createReducer";

export interface UpdateQuestionnaireReducerType {
  loading: boolean;
  error?: any;
  saved: boolean;
  updateQuestionnaireResponse?: UpdateQuestionnairesResponse;
}

const defaultState: UpdateQuestionnaireReducerType = {
  loading: false,
  error: null,
  saved: false,
  updateQuestionnaireResponse: undefined,
};

export const updateQuestionnaireReducer =
  createReducer<UpdateQuestionnaireReducerType>(defaultState, {
    [ActionType.UPDATE_QUESTIONNAIRES](state: UpdateQuestionnaireReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.UPDATE_QUESTIONNAIRES_ERROR](
      state: UpdateQuestionnaireReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: false,
        error: action.payload,
      };
    },

    [ActionType.UPDATE_QUESTIONNAIRES_SUCCESS](
      state: UpdateQuestionnaireReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        saved: true,
        updateQuestionnaireResponse: action.payload,
      };
    },

    [ActionType.UPDATE_QUESTIONNAIRES_RESET](
      state: UpdateQuestionnaireReducerType
    ) {
      return {
        ...state,
        loading: false,
        saved: true,
        error: null,
        updateQuestionnaireResponse: undefined,
      };
    },
  });
